import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const ChevronUp = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="chevron up icon"
    className={`h-${size} w-${size} ${className}`}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.4142 17.4326C20.6332 18.2137 19.3668 18.2137 18.5858 17.4326L12 10.8469L5.41421 17.4326C4.63316 18.2137 3.36684 18.2137 2.58579 17.4326C1.80474 16.6516 1.80474 15.3853 2.58579 14.6042L12 5.19L21.4142 14.6042C22.1953 15.3853 22.1953 16.6516 21.4142 17.4326Z"
    />
  </svg>
)
